import {FiShoppingCart, FiDribbble, FiLinkedin, FiFacebook, FiInstagram, FiTwitter, FiMail, FiYoutube, FiGithub, FiGitlab, FiHelpCircle, FiBookmark, FiSettings} from '../assets/icons/vander'
import collection1 from '../assets/images/categories/running.jpg'
import collection2 from '../assets/images/categories/swimming.jpg'
import collection3 from '../assets/images/categories/tennis.jpg'
import collection4 from '../assets/images/categories/football.jpg'
import collection5 from '../assets/images/categories/basketball.jpg'
import collection6 from '../assets/images/categories/chappal-shoes.jpg'

import catagory1 from "../assets/images/categories/mens.jpg"
import catagory2 from "../assets/images/categories/women.jpg"
import catagory3 from "../assets/images/categories/boys.jpg"
import catagory4 from "../assets/images/categories/allcollection.jpg"

import product1 from '../assets/images/shop/sport-tsirt.jpg'
import product2 from '../assets/images/shop/Sport-shoe.jpg'
import product3 from '../assets/images/shop/men-white-espadrilles-slip-shoes.jpg'
import product4 from '../assets/images/shop/gym-bag.jpg'
import product5 from '../assets/images/shop/dumble.jpg'
import product6 from '../assets/images/shop/Kettlebell.jpg'
import product7 from '../assets/images/shop/mens-jecket.jpg'
import product8 from '../assets/images/shop/Boxing Gloves.jpg'
import product9 from '../assets/images/shop/Headguard.jpg'
import product10 from '../assets/images/shop/men-sun-glasses.jpg'
import product11 from '../assets/images/shop/Yoga Mat.jpg'
import product12 from '../assets/images/shop/casual-men-shorts.jpg'
import product13 from '../assets/images/shop/Gun Massager.jpg'
import product14 from '../assets/images/shop/smart-watch.jpg'
import product15 from '../assets/images/shop/Womens-running-t-shirt.jpg'
import product16 from '../assets/images/shop/Cardio-Shorts.jpg'
import product17 from '../assets/images/shop/apple-smart-watch.jpg'
import product18 from '../assets/images/shop/ladies-sun-glasses.jpg'

import payament1 from '../assets/images/payments/american-express.jpg'
import payament2 from '../assets/images/payments/discover.jpg'
import payament3 from '../assets/images/payments/mastercard.jpg'
import payament4 from '../assets/images/payments/paypal.jpg'
import payament5 from '../assets/images/payments/visa.jpg'

import client1 from '../assets/images/client/01.jpg'
import client2 from '../assets/images/client/02.jpg'
import client3 from '../assets/images/client/03.jpg'
import client4 from '../assets/images/client/04.jpg'
import client5 from '../assets/images/client/05.jpg'
import client6 from '../assets/images/client/06.jpg'
import client7 from '../assets/images/client/16.jpg'
import client8 from '../assets/images/client/07.jpg'
import blog1 from '../assets/images/blog/1.jpg'
import blog2 from '../assets/images/blog/2.jpg'
import blog3 from '../assets/images/blog/3.jpg'
import blog4 from '../assets/images/blog/4.jpg'
import blog5 from '../assets/images/blog/5.jpg'
import blog6 from '../assets/images/blog/6.jpg'
import blog7 from '../assets/images/blog/7.jpg'
import blog8 from '../assets/images/blog/8.jpg'
import blog9 from '../assets/images/blog/9.jpg'


export const collections = [
    {
        image:collection1,
        name:"Running"
    },
    {
        image:collection2,
        name:"Swimming"
    },
    {
        image:collection3,
        name:"Tennis"
    },
    {
        image:collection4,
        name:"Football"
    },
    {
        image:collection5,
        name:"Basketball"
    },
]
export const catagory=[
     { id:1,
        image:catagory1,
        name:"Men"
    },
    {
        id:2,
        image:catagory2,
        name:"Women"
    },
    {  id:3,
        image:catagory3,
        name:"Boys"
    },
    {   id:4,
        image:catagory4,
        name:"Allcatagory"
    },
   


]
export const newProduct =[
    {
        id:1,
        image:product1,
        tag:'-40% Off',
        name:'Sport T-Shirt',
        amount:'₹210.00',
        desRate:'₹160.00',
        offer:true,
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:2,
        image:product2,
        tag:'New',
        name:'Sports Shoe',
        amount:'₹210.00',
        desRate:'₹160.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:3,
        image:product3,
        tag:'',
        name:'Mens White Slip Shoes',
        amount:'₹210.00',
        desRate:'₹160.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:4,
        image:product4,
        tag:'',
        name:'Gym-Bag',
        amount:'₹299.00',
        desRate:'₹199.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:5,
        image:product5,
        tag:'',
        name:'Dumble',
        amount:'299.00',
        desRate:'₹199.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:6,
        image:product6,
        tag:'',
        name:'Kettlebell',
        amount:'₹299.00',
        desRate:'₹199.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:7,
        image:product7,
        tag:'Featured',
        name:'Mens Brown Jecket',
        amount:'₹299.00',
        desRate:'₹199.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:8,
        image:product8,
        tag:'',
        name:' Boxing Gloves',
        amount:'₹299.00',
        desRate:'₹199.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:9,
        image:product9,
        tag:'',
        name:'Headguard',
        amount:'₹299.00',
        desRate:'₹199.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:10,
        image:product10,
        tag:'New',
        name:'Men Sun Glasses',
        amount:'₹299.00',
        desRate:'₹199.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:11,
        image:product11,
        tag:'-25% Off',
        name:'Yoga Mat',
        amount:'₹299.00',
        desRate:'₹199.00',
        offer:true,
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:12,
        image:product12,
        tag:'Featured',
        name:'Black Print T-Shirt',
        amount:'₹299.00',
        desRate:'₹199.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:13,
        image:product13,
        tag:'New',
        name:'Gun Massager',
        rate:'₹299.00',
        desRate:'₹199.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:14,
        image:product14,
        tag:'',
        name:'Smart Watch',
        rate:'₹299.00',
        desRate:'₹199.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:15,
        image:product15,
        tag:'',
        name:'Womens-running-t-shirt',
        rate:'₹299.00',
        desRate:'₹199.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
    {
        id:16,
        image:product16,
        tag:'',
        name:'Cardio-Shorts',
        rate:'₹219.00',
        desRate:'₹169.00',
        desc:'Viverra a consectetur Go sporty this vintage navy and white striped.'
    },
]

export const popularProduct = [
    {
        image:product13,
        tag:'New',
        name:'Orange Luxurious Bag',
        rate:'₹219.00',
        desRate:'₹169.00'
    },
    {
        image:product14,
        tag:'',
        name:'Smart Watch',
        rate:'₹21.00',
        desRate:'₹16.00'
    },
    {
        image:product15,
        tag:'',
        name:'White Sandals',
        rate:'₹21.00',
        desRate:'₹16.00'
    },
    {
        image:product16,
        tag:'',
        name:'Ladies Skirt',
        rate:'₹219.00',
        desRate:'₹169.00'
    },
]

export const footerSocial = [
    {
        icon:FiShoppingCart,
        link:'https://1.envato.market/cartzio-reactjs'
    },
    {
        icon:FiDribbble,
        link:'https://dribbble.com/shreethemes'
    },
    {
        icon:FiLinkedin,
        link:'http://linkedin.com/company/shreethemes'
    },
    {
        icon:FiFacebook,
        link:'https://www.facebook.com/shreethemes'
    },
    {
        icon:FiInstagram,
        link:'https://www.instagram.com/shreethemes'
    },
    {
        icon:FiTwitter,
        link:'https://twitter.com/shreethemes'
    },
    {
        icon:FiMail,
        link:'mailto:support@shreethemes.in'
    },
]

export const footerShopping1 = [
    'Men','Jackets & Coats','Jeans','Loungewear','Polo shirts','Shirts'
]
export const footerShopping2 = [
    'Shorts','Suits Swimwear','T-shirts','Tracksuits','Trousers','Shirts'
]
export const footerShopping3 = [
    'My account','Order History','Wish List','Newsletter','Affiliate','Returns'
]

export const footerServices = [
    {
        icon:'mdi mdi-truck-check-outline',
        name:'Free delivery'
    },
    {
        icon:'mdi mdi-archive',
        name:'Non-contact shipping'
    },
    {
        icon:'mdi mdi-cash-multiple',
        name:'Money-back quarantee'
    },
    {
        icon:'mdi mdi-shield-check',
        name:'Secure payments'
    },
]

export const paymentCart = [
    payament1,payament2,payament3,payament4,payament5
]

export const clientData = [
    {
        image:client1,
        name:'Christa Smith',
        possition:'Manager',
        desc:'" Sportyfi made the processes so easy.Sportyfi instantly increased the amount of interest and ultimately saved us over ₹10,000. "'
    },
    {
        image:client2,
        name:'Christa Smith',
        possition:'Manager',
        desc:'" I highly recommend Sportyfi as the new way to sell your home "by owner". My home sold in 24 hours for the asking price. Best ₹400 you could spend to sell your home. "'
    },
    {
        image:client3,
        name:'Christa Smith',
        possition:'Manager',
        desc:'" My favorite part about selling my home myself was that we got to meet and get to know the people personally. This made it so much more enjoyable! "'
    },
    {
        image:client4,
        name:'Christa Smith',
        possition:'Manager',
        desc:'" Great experience all around! Easy to use and efficient."'
    },
    {
        image:client5,
        name:'Christa Smith',
        possition:'Manager',
        desc:'" Sportyfi made selling my home easy and stress free. They went above and beyond what is expected.. "'
    },
    {
        image:client6,
        name:'Christa Smith',
        possition:'Manager',
        desc:'" Sportyfi is fair priced, quick to respond, and easy to use. I highly recommend their services! "'
    },
]

export const categories = [
    {
        image:collection4,
        title:'Smart Watch'
    },
    {
        image:collection5,
        title:'Sunglasses'
    },
    {
        image:collection6,
        title:'Casual Shoes'
    },
    {
        image:collection2,
        title:'Ladies Wear'
    },
    {
        image:collection3,
        title:'Kids Wear'
    },
    {
        image:collection1,
        title:'Gents Wear'
    },
]

export const colorFilter = [
    'bg-red-600','bg-indigo-600','bg-emerald-600','bg-slate-900','bg-gray-400','bg-orange-600','bg-violet-600'
]

export const brandFilter = [
    'Alexander McQueen','Alexander Wang','Allegra K','AllSaints','Badgley Mischka','Baldinini'
]

export const sizeFilter = [
    'S','M','L','XL','2XL','3XL','4XL'
]

export const cartData = [
    {
        image:product1,
        name:'T-shirt (M)',
        qtn:3,
        price:280
    },
    {
        image:product2,
        name:'Sneaker Shoes',
        qtn:1,
        price:160
    },
    {
        image:product3,
        name:'Ladies Skirt',
        qtn:1,
        price:500
    },
]

export const brand = [
    {
        id:1,
        name:[
            'Adrianna Papell','AG - Adriano','Aglini','Alberta Ferretti','Alexander McQueen','Alexander Wang','Allegra K','AllSaints','Badgley Mischka','Baldinini','Balenciaga','Ballantyne','Ballard Designs','Bally','Balmain','Barba','Barbour'
        ]
    },
    {
        id:2,
        name:[
            'Barena','BaubleBar','Baxton Studio','BCBGeneration','Bcbgmaxazria','Beatrice .B','C.P. Company','Cafènoir','Caliban','Camper','Carhartt Work in Progress','Carolines Treasures','Carve Designs','Casadei','Catch Some Rays','Certified International','Champion'
        ]
    },
    {
        id:3,
        name:[
            'Cherokee','Chiara Ferragni','Daniele Alessandrini','Daniele Fiesoli','Demdaco','Department Five','Design Toscano','Designq','Desigual','Dolce Vita','Dondup','Dorothee Schumacher','Doucals','Dr. Martens','Logitech','Sportyfi',
        ]
    },
]

export const promiseData = [
    {
        icon:'mdi mdi-truck-check-outline',
        title:'Free Shipping',
        desc:'The phrasal sequence of the is now so that many campaign and benefit'
    },
    {
        icon:'mdi mdi-account-arrow-right-outline',
        title:'24/7 Support',
        desc:'The phrasal sequence of the is now so that many campaign and benefit'
    },
    {
        icon:'mdi mdi-cash-multiple',
        title:'Payment Process',
        desc:'The phrasal sequence of the is now so that many campaign and benefit'
    },
]
export const teamData = [
    {
        image:client4,
        name:'Jack John',
        possition:'Designer'
    },
    {
        image:client7,
        name:'Krista John',
        possition:'Designer'
    },
    {
        image:client6,
        name:'Roger Jackson',
        possition:'Designer'
    },
    {
        image:client8,
        name:'Johnny English',
        possition:'Designer'
    },
]

export const userOrder = [
    {
        no:'7107',
        date:'13th March 2024',
        status:'Delivered',
        total:'₹ 320',
        item:'for 2items'
    },
    {
        no:'8007',
        date:'5th May 2024',
        status:'Processing',
        total:'₹ 800',
        item:'for 1items'
    },
    {
        no:'8008',
        date:'19th June 2024',
        status:'Canceled',
        total:'₹ 800',
        item:'for 1items'
    },
]

export const userFvtItem = [
    {
        image:product17,
        name:'Apple Smart Watch',
        rate:' ₹210.00',
        descRate:'₹160.00'
    },
    {
        image:product6,
        name:'Ladies Top',
        rate:' ₹2011.00',
        descRate:'₹16.00'
    },
    {
        image:product18,
        name:'Ladies Sunglasses',
        rate:' ₹21.00',
        descRate:'₹16.00'
    },
]

export const paymentMethod = [
    {
        image:payament5,
        name:'Visa ending in 4578',
        expires:'Expires in 13/03/2024'
    },
    {
        image:payament1,
        name:'American Express ending in 4578',
        expires:'Expires in 05/05/2024'
    },
    {
        image:payament2,
        name:'Discover ending in 4578',
        expires:'Expires in 19/07/2024'
    },
    {
        image:payament3,
        name:'Master Card ending in 4578',
        expires:'Expires in 20/07/2024'
    },
]

export const userSocial = [
    {
        icon:FiTwitter,
        title:'Twitter',
        placeholder:'Twitter Profile Name',
        desc:'Add your Twitter username (e.g. jesus).'
    },
    {
        icon:FiFacebook,
        title:'Facebook',
        placeholder:'Facebook Profile Name',
        desc:'Add your Facebook username (e.g. jesus).'
    },
    {
        icon:FiInstagram,
        title:'Instagram',
        placeholder:'Instagram Profile Name',
        desc:'Add your Instagram username (e.g. jesus).'
    },
    {
        icon:FiLinkedin,
        title:'Linkedin',
        placeholder:'Linkedin Profile Name',
        desc:'Add your Linkedin username (e.g. jesus).'
    },
    {
        icon:FiYoutube,
        title:'Youtube',
        placeholder:'Youtube url.',
        desc:'Add your Youtube url.'
    }
]

export const blogData = [
    {
        id:1,
        image:blog1,
        title:'The History Of Patterned Dresses',
        desc:"This is required when, for example, the final text is not yet available.",
        date:'13th Sep 2024'
    },
    {
        id:2,
        image:blog2,
        title:'Swimsuits For The Whole Family',
        desc:"This is required when, for example, the final text is not yet available.",
        date:'29th Nov 2024'
    },
    {
        id:3,
        image:blog3,
        title:'Good Products For Lovely Girls',
        desc:"This is required when, for example, the final text is not yet available.",
        date:'29th Dec 2024'
    },
    {
        id:4,
        image:blog4,
        title:'Latest Swimsuit Model This Year',
        desc:"This is required when, for example, the final text is not yet available.",
        date:'13th March 2024'
    },
    {
        id:5,
        image:blog5,
        title:'Summer Travel Fashion 2023',
        desc:"This is required when, for example, the final text is not yet available.",
        date:'5th May 2024'
    },
    {
        id:6,
        image:blog6,
        title:'Exploring the Timeless Allure of Fashion',
        desc:"This is required when, for example, the final text is not yet available.",
        date:'19th June 2024'
    },
    {
        id:7,
        image:blog7,
        title:'A Chic Journey Through Fashion Trends',
        desc:"This is required when, for example, the final text is not yet available.",
        date:'20th June 2024'
    },
    {
        id:8,
        image:blog8,
        title:'Unique Autumn Fashion Ideas',
        desc:"This is required when, for example, the final text is not yet available.",
        date:'31st Aug 2024'
    },
    {
        id:9,
        image:blog9,
        title:'Tips For Wearing Loose T-shirts',
        desc:"This is required when, for example, the final text is not yet available.",
        date:'1st Sep 2024'
    },
]

export const social = [
    FiFacebook,FiInstagram,FiTwitter,FiLinkedin,FiGithub,FiYoutube,FiGitlab
]

export const jobData = [
    {
        name:'Frontend Developer',
        openings:'Total Openings: 1'
    },
    {
        name:'Business Development Manager',
        openings:'Total Openings: 2'
    },
    {
        name:'Backend Developer',
        openings:'Total Openings: 4'
    },
]
export const faqAbout = [
    {
        icon:FiHelpCircle,
        title:'FAQs',
        desc:'The phrasal sequence of the is now so that many campaign and benefit'
    },
    {
        icon:FiBookmark,
        title:'Guides / Support',
        desc:'The phrasal sequence of the is now so that many campaign and benefit'
    },
    {
        icon:FiSettings,
        title:'Support Request',
        desc:'The phrasal sequence of the is now so that many campaign and benefit'
    },
]

export const guidenceData = [
    {
        name:'Getting started',
        features:['Deciding to purchase','List your space','Landing an experience or adventure','Top uses questions']
    },
    {
        name:'Your calendar',
        features:['Pricing & availability','Booking settings','Responding to enquiries & requests','Snoozing or deactivating your listing']
    },
    {
        name:'Your listings',
        features:['Updating your listing','Neighbourhoods','Listing photos & photography','Cartzio Plus','API-connected software']
    },
    {
        name:'How payouts work',
        features:['Getting paid','Adding payout info','Your payout status','Donations','Taxes']
    },
    {
        name:'Your reservations',
        features:['Cartzio safely','Cartzio Experiences and Adventures','Changing a reservation','Cancelling a reservation','Long-term reservations']
    },
    {
        name:'Reservation help',
        features:['Help with a reservation or guest','Guest cancellations']
    },
    {
        name:'Your account',
        features:['Your profile','Account security','Identification & verifications','Reviews','Superhost status']
    },
]

export const faqData = [
    {
        id:1,
        title:'How does it work ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:2,
        title:'Do I need a designer to use Cartzio ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:3,
        title:'What do I need to do to start selling ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:4,
        title:'What happens when I receive an order ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
]

export const termsData = [
    'Digital Marketing Solutions for Tomorrow','Our Talented & Experienced Marketing Agency','Create your own skin to match your brand','Digital Marketing Solutions for Tomorrow','Our Talented & Experienced Marketing Agency','Create your own skin to match your brand'
]

export const salesData = [
    {
        tag:'20% Off',
        title:'Sale 20% Off',
        desc:"for 20% Off",
        code:'SALE20OFF'
    },
    {
        tag:'30% Off',
        title:'Sale 30% Off',
        desc:"for 30% Off",
        code:'SALE30OFF'
    },
    {
        tag:'50% Off',
        title:'Sale 50% Off',
        desc:"for 50% Off",
        code:'SALE50OFF'
    },
    {
        tag:'75% Off',
        title:'Sale 75% Off',
        desc:"for 75% Off",
        code:'SALE75OFF'
    },
]

export const commentsData = [
    {
        image:client1,
        name:'Calvin Carlo',
        time:'13th March 2024 at 01:00 pm',
        desc:'" There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour "'
    },
    {
        image:client2,
        name:'Calvin Carlo',
        time:'5th May 2024 at 10:00 am',
        desc:'" There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour "'
    },
    {
        image:client3,
        name:'Calvin Carlo',
        time:'19th June 2024 at 00:00 1m',
        desc:'" There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour "'
    },
    {
        image:client4,
        name:'Calvin Carlo',
        time:'20th June 2024 at 01:30 pm',
        desc:'" There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour "'
    },
]